import React, { useState } from 'react';
import cubejs, { Filter, ResultSet } from '@cubejs-client/core';

import { LOCAL_TIMEZONE } from 'domains/org/getty/constants';
import { getCubeApiUrl } from '../../cubeApiUrl';
import { QueryStatus, QUERY_STATUS } from './queryStatus';

export const dateToYMD = (d: Date) => d.toISOString().replace(/[T].*$/, '');

export type QueryProps = {
  siteRef?: string | null;
  tourRef?: string | null;
  fromDate: Date;
  toDate: Date;
  metadata: {
    siteName: string;
    tourName: string;
  };
};

export type QueryResponse = {
  resultSet?: ResultSet<any>;
  error?: Error;
}

const initialStatus: QueryStatus = {
  type: QUERY_STATUS.READY
}

export const useQuery = () => {

  const [queryStatus, setQueryStatus] = useState<QueryStatus>(initialStatus);
  
  const sendQuery =  (token: string, queryData: QueryProps) => {
    setQueryStatus({
      type: QUERY_STATUS.LOADING,
      queryProps: queryData
    });
    
    const cubeApi = cubejs(token, { apiUrl: getCubeApiUrl() });
    const { fromDate, toDate, tourRef } = queryData;
    const filters: Array<Filter> = [];
    const from = dateToYMD(fromDate);
    const to = dateToYMD(toDate);

    if (tourRef)
      filters.push({
        member: 'ViewDensity.tour_ref',
        operator: 'equals',
        values: [tourRef]
      });

    cubeApi.load({
      measures: ['ViewDensity.visitors'],
      timeDimensions: [
        {
          dimension: 'ViewDensity.hour',
          dateRange: [from, to],
          granularity: 'hour'
        }
      ],
      order: [['ViewDensity.visitors', 'desc']],
      dimensions: ['ViewDensity.space_ref'],
      timezone: LOCAL_TIMEZONE,
      filters
    })
    .then((resultSet) => {
      setQueryStatus({
        type: QUERY_STATUS.SUCCESS,
        queryProps: queryData,
        result: resultSet,
      });

    })
    .catch((e: any) => {
      setQueryStatus({
        type: QUERY_STATUS.ERROR,
        errorMessage: e.message || JSON.stringify(e),
        queryProps: queryData
      });
    })
  }

  return {sendQuery, queryStatus};

};